import { render, staticRenderFns } from "./AccessProjectModal.vue?vue&type=template&id=5e188a3d&scoped=true"
import script from "./AccessProjectModal.vue?vue&type=script&lang=js"
export * from "./AccessProjectModal.vue?vue&type=script&lang=js"
import style0 from "./AccessProjectModal.vue?vue&type=style&index=0&id=5e188a3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e188a3d",
  null
  
)

export default component.exports